/**
 * Component for rendering a the alternate Tooltip variants from the OR
 * style guide that are not supported by Material UI Typography
 */
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import Hidden from '@material-ui/core/Hidden';

const propTypes = {
  children: PropTypes.shape({}).isRequired,
};

export function UnstyledORTooltip({ children, ...rest }) {
  return (
    <React.Fragment>
      <Hidden smDown>
        <Tooltip placement="left" {...rest}>
          {children}
        </Tooltip>
      </Hidden>

      <Hidden mdUp>
        <Tooltip placement="bottom" {...rest}>
          {children}
        </Tooltip>
      </Hidden>
    </React.Fragment>
  );
}

UnstyledORTooltip.propTypes = propTypes;

export default UnstyledORTooltip;
